/*
 * BITCO product-gallery lightbox.
 * Clicking a main gallery image opens a full-screen popup with the image shown
 * large, a horizontally scroll-snapping track of every product image, prev/next
 * arrows, keyboard (←/→/Esc) and click-backdrop/close to dismiss. Built lazily
 * from the images already in the gallery, so no duplicate markup ships.
 */
(function () {
  var overlay, track, slides = [], current = 0;

  var ICON_CLOSE = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  var ICON_PREV = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var ICON_NEXT = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'bitco-lightbox';
    overlay.setAttribute('hidden', '');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<button type="button" class="bitco-lightbox__close" aria-label="Close">' + ICON_CLOSE + '</button>' +
      '<button type="button" class="bitco-lightbox__nav bitco-lightbox__nav--prev" aria-label="Previous image">' + ICON_PREV + '</button>' +
      '<button type="button" class="bitco-lightbox__nav bitco-lightbox__nav--next" aria-label="Next image">' + ICON_NEXT + '</button>' +
      '<div class="bitco-lightbox__track"></div>';
    document.body.appendChild(overlay);
    track = overlay.querySelector('.bitco-lightbox__track');
    overlay.querySelector('.bitco-lightbox__close').addEventListener('click', close);
    overlay.querySelector('.bitco-lightbox__nav--prev').addEventListener('click', function () { go(-1); });
    overlay.querySelector('.bitco-lightbox__nav--next').addEventListener('click', function () { go(1); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    var scrollRaf;
    track.addEventListener('scroll', function () {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = null;
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        if (idx !== current) { current = idx; updateArrows(); }
      });
    });
  }

  function biggerUrl(url) {
    if (!url) return url;
    // Upgrade Shopify CDN width param for a crisper zoom; leave other URLs as-is.
    return url.replace(/([?&]width=)\d+/, '$1' + 2000);
  }

  function open(gallery, index) {
    if (!overlay) build();
    var imgs = [].slice.call(gallery.querySelectorAll('.bitco-gallery__image'));
    track.innerHTML = '';
    slides = imgs.map(function (im) {
      var slide = document.createElement('div');
      slide.className = 'bitco-lightbox__slide';
      var big = document.createElement('img');
      big.className = 'bitco-lightbox__img';
      big.src = biggerUrl(im.getAttribute('src') || im.currentSrc || '');
      big.alt = im.getAttribute('alt') || '';
      big.decoding = 'async';
      slide.appendChild(big);
      track.appendChild(slide);
      return slide;
    });
    if (!slides.length) return;
    current = Math.max(0, Math.min(slides.length - 1, index));
    overlay.removeAttribute('hidden');
    document.documentElement.classList.add('bitco-lightbox-open');
    // jump (no animation) to the clicked image, then enable snap scrolling
    requestAnimationFrame(function () {
      track.scrollLeft = slides[current].offsetLeft;
      updateArrows();
    });
    document.addEventListener('keydown', onKey);
    overlay.querySelector('.bitco-lightbox__close').focus();
  }

  function close() {
    if (!overlay) return;
    overlay.setAttribute('hidden', '');
    document.documentElement.classList.remove('bitco-lightbox-open');
    document.removeEventListener('keydown', onKey);
  }

  function go(dir) {
    current = Math.max(0, Math.min(slides.length - 1, current + dir));
    // Direct assignment, not scrollTo({behavior:'smooth'}): scroll-snap-type:
    // mandatory cancels programmatic smooth scrolls in Chrome, so the arrows/
    // keyboard would silently no-op. The snap makes the jump land cleanly.
    track.scrollLeft = slides[current].offsetLeft;
    updateArrows();
  }

  function updateArrows() {
    if (!overlay) return;
    overlay.querySelector('.bitco-lightbox__nav--prev').disabled = current <= 0;
    overlay.querySelector('.bitco-lightbox__nav--next').disabled = current >= slides.length - 1;
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') go(-1);
    else if (e.key === 'ArrowRight') go(1);
  }

  document.addEventListener('click', function (e) {
    var frame = e.target.closest && e.target.closest('.bitco-gallery__frame');
    if (!frame) return;
    var gallery = frame.closest('media-gallery') || frame.closest('.bitco-gallery');
    if (!gallery) return;
    e.preventDefault();
    var imgs = [].slice.call(gallery.querySelectorAll('.bitco-gallery__image'));
    var idx = imgs.indexOf(frame.querySelector('.bitco-gallery__image'));
    open(gallery, idx < 0 ? 0 : idx);
  });
})();
